import axios from 'axios'

export default {
    namespaced: true,
    state: {
        localSettings: [],
        collegeCardLocalSettings: [],
        studentFundingLocalSettings: [],
    },
    mutations: {
        SET_LOCAL_SETTINGS(state, payload) {
            state.localSettings = payload;
        },
        SET_COLLEGE_CARD_LOCAL_SETTINGS(state, payload) {
            state.collegeCardLocalSettings = payload;
        },
        SET_STUDENT_FUNDING_LOCAL_SETTINGS(state, payload) {
            state.studentFundingLocalSettings = payload;
        },
    },
    actions: {
        FetchLocalSettings({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/local-settings/fetch`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            response.data.payload.keyValuePairs = CoalesceJSON(response.data.payload.keyValuePairs);
                            commit('SET_LOCAL_SETTINGS', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchLocalSettings: ${error.message}`));
            });
        },
        FetchCollegeCardLocalSettings({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/college-cards/local-settings/fetch`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            response.data.payload = CoalesceJSON(response.data.payload);
                            response.data.payload.keyValuePairs = CoalesceJSON(response.data.payload.keyValuePairs);
                            commit('SET_COLLEGE_CARD_LOCAL_SETTINGS', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchCollegeCardLocalSettings: ${error.message}`));
            });
        },
        FetchStudentFundingLocalSettings({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/student-funding/local-settings/fetch`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            response.data.payload = CoalesceJSON(response.data.payload);
                            response.data.payload.KeyValuePairs = CoalesceJSON(response.data.payload.KeyValuePairs);
                            commit('SET_STUDENT_FUNDING_LOCAL_SETTINGS', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchStudentFundingLocalSettings: ${error.message}`));
            });
        },
    },
    getters: {
        LocalSettings(state) { return state.localSettings; },
        CollegeCardLocalSettings(state) { return state.collegeCardLocalSettings; },
        StudentFundingLocalSettings(state) { return state.studentFundingLocalSettings; },
    }
}
function CoalesceJSON(object, returnObject) {
    if (object == null || object == '') return returnObject;
    else if (typeof object == 'object') return object;
    else return JSON.parse(object);
};
